import React, { ReactNode, Children, ReactElement } from 'react'
import { StepperStep, StepperStepProps } from '@shared/ui/Form/Stepper/Step/StepperStep'
import s from './Stepper.module.sass'
interface StepperProps {
  /** <Stepper.Step /> components only*/
  children: ReactNode

  // индексация от нуля, поверьте, добавлять единичку в тайтлах удобнее на будущее
  activeStep: number
}

export const Stepper = ({ activeStep, children }: StepperProps) => {
  const rawChildren = Children.toArray(children)
  const isValidStep = (item: unknown): item is ReactElement<StepperStepProps> => React.isValidElement(item)
  const thisSteps = rawChildren.filter(isValidStep)

  const items = thisSteps.reduce<ReactElement<StepperStepProps>[]>((acc, item, index) => {
    const isCurrent = activeStep === index
    const isPast = activeStep > index
    const whenNotCurrent = isPast ? 'completed' : 'inactive'
    const state = isCurrent ? 'progress' : whenNotCurrent
    acc.push(React.cloneElement(item, { state, index: index + 1, key: index }))

    if (index !== thisSteps.length - 1) {
      acc.push(<div className={s[`divider${activeStep > 0 ? '-narrow' : ''}`]} key={`divider-${index}`} />)
    }
    return acc
  }, [])

  const content = thisSteps[activeStep]?.props.children

  return (
    <div className={s.stepper}>
      <div className={s.steps}>{items}</div> {content}
    </div>
  )
}

Stepper.Step = StepperStep
